<template>
<v-container>
  <v-row no-gutters class="text-center text-h5 primary--text font-weight-bold">
    <translate>Choose a template, give us all the pics and videos you have and we setup and take care of everything else. In less than 10 days, your brand-new beautiful website you can be proud of will be available online!</translate>
  </v-row>
  <v-row no-gutters class="white pt-8 pb-12 px-8 mt-8">
    <TableSellingMobile v-if="isMobile" @openDialog="openDialog"/>
    <TableSelling v-else @openDialog="openDialog"/>
  </v-row>
</v-container>
</template>

<script>
import TableSelling from '@/components/Selling/TableSelling'
import TableSellingMobile from '@/components/Selling/TableSellingMobile'
export default {
  name: "Website",
  components: {TableSelling, TableSellingMobile},
  props: {
  },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  computed: {},
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 700
    },
    openDialog(data) {
      this.$emit('openDialog', data)
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
};
</script>